import { MultiChoiceFilter } from '@model';

export class MeteringPointFilterSettings {
  filterOnMisc?: boolean;
  miscMultiChoiceFilter?: MultiChoiceFilter;
}
